import React, { useReducer } from 'react';
import { Action, } from '../utils/types';
const State = React.createContext(undefined);
const ContextDispatch = React.createContext(undefined);
function formStateReducer(state, action) {
    switch (action.type) {
        case Action.SUBMIT_KONTOOPPLYSNINGER: {
            return Object.assign(Object.assign({}, state), { kontoopplysninger: Object.assign(Object.assign({}, action.kontoopplysninger), { submitted: true }) });
        }
        case Action.UPDATE_UTBETALINGSDETALJER: {
            return Object.assign(Object.assign({}, state), { utbetalingsdetaljer: action.utbetalingsdetaljer });
        }
        case Action.SUBMIT_CUSTOMER_DATA: {
            return Object.assign(Object.assign({}, state), { customerData: action.customerData });
        }
        case Action.UPDATE_AMOUNT_DATA: {
            return Object.assign(Object.assign({}, state), { amountData: Object.assign(Object.assign({}, action.amountData), { submitted: true }) });
        }
        case Action.SUBMIT_RAADGIVNING_DATA: {
            return Object.assign(Object.assign({}, state), { raadgivningData: Object.assign({}, action.raadgivningData) });
        }
        case Action.SUBMIT_VALGT_RISIKOPROFIL: {
            return Object.assign(Object.assign({}, state), { profildata: action.risikoprofil });
        }
        case Action.SUBMIT_IDD_ANBEFALING: {
            return Object.assign(Object.assign({}, state), { risikoanbefaling: action.anbefaling });
        }
        case Action.SUBMIT_PORTEFØLJE_FOR_ALLE_PROFILER: {
            return Object.assign(Object.assign({}, state), { porteføljedata: action.porteføljedata });
        }
        case Action.SUBMIT_CUSTOM_PAYOUT_AGE: {
            return Object.assign(Object.assign({}, state), { barnetsAlderVedUttak: action.barnetsAlderVedUttak });
        }
        default: {
            throw new Error(`Unhandled action: ${action}`);
        }
    }
}
export const FormStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(formStateReducer, initialFormState);
    return (React.createElement(State.Provider, { value: state },
        React.createElement(ContextDispatch.Provider, { value: dispatch }, children)));
};
export const useFormState = () => {
    const context = React.useContext(State);
    if (context === undefined) {
        throw new Error('useFormState must be used within a FormStateProvider');
    }
    return context;
};
export const useFormDispatch = () => {
    const context = React.useContext(ContextDispatch);
    if (context === undefined) {
        throw new Error('useFormDispatch must be used within a FormStateProvider');
    }
    return context;
};
export const useFormContext = () => {
    return [useFormState(), useFormDispatch()];
};
const initialFormState = {
    kontoopplysninger: {
        spareformål: undefined,
        kontonavn: '',
        barnetsFnr: '',
        submitted: false,
    },
    utbetalingsdetaljer: {
        uttaksalder: 67,
        antallUtbetalingsår: 10,
    },
    raadgivningData: {
        ref: undefined,
        type: undefined,
        egnethet: {
            groups: undefined,
            answers: [],
        },
        fatca: {
            groups: undefined,
            answers: [],
        },
    },
    risikoanbefaling: undefined,
    profildata: undefined,
    porteføljedata: undefined,
    customerData: {
        firstName: '',
        surname: '',
        email: '',
        ssn: '',
    },
    amountData: {
        annuity: '',
        lumpSum: '',
        submitted: false,
    },
    barnetsAlderVedUttak: undefined,
};
